// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/" + {"274":"Home","298":"HowToPlay","316":"Leaderboard","524":"app","670":"AppLayout"}[chunkId] + "." + {"274":"102ef2c91c5a47e31210","298":"f82969d1c9696119adb3","316":"0d65dce5c0ffa1edbaad","524":"1a4cf7d062fb7b6a54fe","670":"4ff46b639a71d60606ca"}[chunkId] + ".chunk.js";
};